import { Button } from '@ui-kit'
import { useEffect } from 'react'

import { CHECKOUT_CURRENT_STEP } from '../constants'

export const Confirmation = () => {
  useEffect(() => {
    localStorage.removeItem(CHECKOUT_CURRENT_STEP)
  }, [])

  const handleConfirmation = () => {
    window.location.reload()
  }

  return (
    <div>
      <h1>Confirmation</h1>

      <Button onClick={handleConfirmation}>Reload Page</Button>
    </div>
  )
}

Confirmation.displayName = 'CheckoutConfirmation'
